// Minimum viewport aspect ratio required to use landscape view
// Viewports narrower than this use default "large" view.
export const MOBILE_NOW_PLAYING_LANDSCAPE_ASPECT_RATIO = '14 / 10';

// Maximum viewport height, in pixels, required to use landscape view
// Viewports taller than this use default "large" view.
export const MOBILE_NOW_PLAYING_LANDSCAPE_MAX_HEIGHT = 580;
